export enum PurchaseType {
  OTHER = 'Just buy for Others',
  GIFT = 'Send it as Gift'
}
